import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import Card from 'cityads-v3/components/Card/Card';
import ContactForm from './ContactForm';

import classes from './ContactFormCard.scss';

@withTranslation(['main'], { i18n, wait: !!window })
export default class ContactFormCard extends Component {
  static propTypes = {
    t: PropTypes.func
  }

  render() {
    const { t, className } = this.props;

    return (
      <Card
        className = {classNames(classes.contactCard, className)}
        title     = {<h2 className={classes.cardHeaderTitle}>{t('contactFormCard.title')}</h2>}
        subtitle  = {t('contactFormCard.subtitle')}
        cardHeaderClasses = {{
          root     : classes.contactHeader,
          title    : classes.contactTitle,
          subheader: classes.contactSubtitle,
        }}
      >
        <ContactForm
          className   = {classes.contactForm}
        />
      </Card>
    );
  }
}
